<template>
  <div>
    <button
      :id="id"
      :disabled="false"
      class="btn spdo-button-sso spdo-button_line spdo-button_filled_white-color realm-button"
      type="button"
      @click="callback(realm)"
      @mouseover="handleHover(true)"
      @mouseleave="handleHover(false)"
    >
      <v-img
        :src="img.default"
        class="realm-logo"
        width="48"
        height="48"
        :contain="true"
        aspect-ratio="true"
      />
    </button>
    <b-tooltip
      :target="id"
      :title="tooltipTitle"
      variant="light"
      placement="bottomright"
    >
      {{ tooltipTitle }}
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'SsoRealmButton',
  props: {
    realm: { type: String },
    logo: { type: String, default: 'completed-requests.svg' },
  },
  data: () => ({
    hover: false,
    img: '',
  }),
  computed: {
    id() { return `realm-button-${this.realm}`; },
    tooltipTitle() { return `Login via ${this.realm}`; },
  },
  async created() {
    // eslint-disable-next-line import/no-dynamic-require,global-require,prefer-template
    this.img = await import('@/assets/images/' + this.logo);
  },
  methods: {
    handleHover(s) {
      this.hover = s;
    },
    callback(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
    .realm-button {
        vertical-align: middle;
        color: var(--margaritas) !important;
        font-weight: 400;
    }

    .realm-logo {
        display: inline-block;
        vertical-align: middle;
        padding: 4px 8px;
        border-radius: 3px;
    }

    .realm-text {
        display: none;
    }

    .realm-text-hover {
        margin-left: 7px;
    }
</style>
